import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/news';

export default function HeroSection() {
  const mainFeatured = featuredArticles[0];
  const subFeatured = featuredArticles.slice(1, 4);

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20entertainment%20news%20backdrop%20with%20abstract%20geometric%20patterns%2C%20warm%20deep%20red%20and%20amber%20gradient%2C%20mysterious%20atmosphere%2C%20modern%20minimal%20design%2C%20soft%20texture%20overlay%2C%20editorial%20style%2C%20clean%20composition%2C%20no%20text%2C%20no%20people&width=1600&height=900&seq=hero-bg-51hl&orientation=landscape"
          alt="51黑料官网入口 - 娱乐八卦资讯平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 w-full h-full px-4 md:px-6 flex flex-col justify-end pb-10 md:pb-14">
        <div className="flex flex-col lg:flex-row gap-6">
          {mainFeatured && (
            <Link
              to={`/article/${mainFeatured.slug}`}
              className="flex-1 group cursor-pointer"
            >
              <span className="inline-block px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium mb-3">
                头条爆料
              </span>
              <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 leading-tight mb-3 group-hover:text-accent-300 transition-colors">
                {mainFeatured.title}
              </h1>
              <p className="text-sm md:text-base text-background-300 line-clamp-2 max-w-2xl">
                {mainFeatured.excerpt}
              </p>
              <div className="flex items-center gap-3 mt-3 text-xs text-background-400">
                <span>{mainFeatured.date}</span>
                <span>·</span>
                <span>{mainFeatured.views.toLocaleString()} 阅读</span>
              </div>
            </Link>
          )}

          <div className="lg:w-[340px] flex flex-col gap-3">
            {subFeatured.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group flex items-start gap-3 p-3 rounded-lg bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-all cursor-pointer"
              >
                <div className="w-16 h-16 rounded-md overflow-hidden flex-shrink-0">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-medium text-background-50 line-clamp-2 leading-snug group-hover:text-accent-300 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-xs text-background-400 mt-1">
                    {article.views.toLocaleString()} 阅读
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}